import React from "react";
import dateFns from "date-fns";
import "./Calender.css";
import {
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography,
  Container,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import EventIcon from '@material-ui/icons/Event';
import DescriptionIcon from '@material-ui/icons/Description';
import GetAppIcon from '@material-ui/icons/GetApp';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import CloseIcon from '@material-ui/icons/Close';
import EventService from "./Locality/Service/eventService";
import CalenderAssignmentService from "./Locality/Service/calenderAssignmentService";
import StudentService from "./Locality/Service/studentService";
import StudentCards from "./UserProfileCard";

const getDocumentFileName = (url) => {
  try {
    const path = (url || "").split("/").pop() || url;
    return (path || "").split("?")[0] || "school-calendar.docx";
  } catch {
    return "school-calendar.docx";
  }
};

const getDocumentExtension = (url) => {
  const name = getDocumentFileName(url);
  const ext = (name.split(".").pop() || "doc").toLowerCase();
  return ext === "docx" || ext === "doc" ? ext.toUpperCase() : "DOC";
};

const formatDateDDMMYYYY = (value) => {
  if (!value) return "—";
  const s = String(value).trim();
  if (/^\d{2}-\d{2}-\d{4}$/.test(s)) return s;
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}-${iso[2]}-${iso[1]}`;
  const d = new Date(s);
  if (!Number.isNaN(d.getTime())) {
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}-${mm}-${d.getFullYear()}`;
  }
  return s;
};

const VIDEO_EXT = /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?|$)/i;
const AUDIO_EXT = /\.(mp3|wav|ogg|m4a|aac|flac|mpeg)(\?|$)/i;

const getMediaTypeFromUrl = (url) => {
  if (!url || typeof url !== "string") return "image";
  const lower = url.split("?")[0].toLowerCase();
  if (VIDEO_EXT.test(lower)) return "video";
  if (AUDIO_EXT.test(lower)) return "audio";
  return "image";
};

const getDownloadFileName = (url, eventName, mediaType) => {
  const base = (eventName || "event-media").replace(/[^\w.\-]+/g, "_").slice(0, 60);
  const fromUrl = (url || "").split("?")[0].split("/").pop() || "";
  if (fromUrl && fromUrl.includes(".")) return fromUrl;
  const ext = mediaType === "video" ? "mp4" : mediaType === "audio" ? "mp3" : "jpg";
  return `${base}.${ext}`;
};

const downloadEventMedia = async (url, eventName, mediaType) => {
  if (!url) return;
  const filename = getDownloadFileName(url, eventName, mediaType);
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("fetch failed");
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(props.location.search);
    const currentMonth = queryParams.get("currentMonth");

    this.state = {
      list: [],
        studentList:[],
        studentId:'',
        classId:'',
      currentMonth: new Date(),
      selectedDate: new Date(),
      event: [],
      error: null,
      userselectedDate:'',
      schoolCalenderDocuments: [],
      mediaPlayer: { open: false, url: "", type: "image", title: "" },
    };
  }

  openMediaPlayer = (url, type, title = "") => {
    this.setState({ mediaPlayer: { open: true, url, type, title } });
  };

  closeMediaPlayer = () => {
    this.setState({ mediaPlayer: { open: false, url: "", type: "image", title: "" } });
  };

  renderEventMediaTile = (mediaUrl, eventName, imgIndex) => {
    const mediaType = getMediaTypeFromUrl(mediaUrl);
    const tileStyle = {
      width: "100%",
      height: "150px",
      borderRadius: "4px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid #e0e0e0",
    };

    if (mediaType === "video") {
      return (
        <Box
          key={imgIndex}
          style={{ ...tileStyle, backgroundColor: "#0f2d4d", color: "#fff" }}
          onClick={() => this.openMediaPlayer(mediaUrl, "video", eventName)}
          role="button"
          tabIndex={0}
        >
          <PlayArrowIcon style={{ fontSize: 48 }} />
        </Box>
      );
    }

    if (mediaType === "audio") {
      return (
        <Box
          key={imgIndex}
          style={{ ...tileStyle, backgroundColor: "#eef4ff", color: "#1769d6" }}
          onClick={() => this.openMediaPlayer(mediaUrl, "audio", eventName)}
          role="button"
          tabIndex={0}
        >
          <AudiotrackIcon style={{ fontSize: 40 }} />
        </Box>
      );
    }

    return (
      <img
        key={imgIndex}
        src={mediaUrl}
        alt={`Event media ${imgIndex + 1}`}
        style={{ ...tileStyle, objectFit: "cover" }}
        onClick={() => this.openMediaPlayer(mediaUrl, "image", eventName)}
      />
    );
  };

  handleClicks = (id,date) => {
 
    this.props.history.push("/app/activitydetails/" + id);
  };

  handleClick = (id,date) => {
    console.log(date)
    const selectedDate = dateFns.format(date, "YYYY-MM-DD");


    const userDetails = JSON.parse(localStorage.getItem("userDetail"));

    this.setState({userselectedDate:date});
    EventService.calenderassignmentList({ schooleId: userDetails.schooleId,"studentId":this.state.studentId,"classId":this.state.classId._id,"date":selectedDate })
      .then((res) => {
        this.setState({ event: res, list: this.state.list });
      })
      .catch((err) => {
        this.setState({ error: err.message });
      });
  };

  componentDidMount() {
    this.fetchStudentList();
    this.fetchSchoolCalenderDocument();
    const date = dateFns.format(this.state.currentMonth, "YYYY-MM-DD");
    //this.getEventList(date);
    
    // Listen for calendar event changes to refresh the list
    this.handleCalendarEventChange = (event) => {
      // Refresh the event list when an event is added, updated, or deleted
      const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      const date = dateFns.format(this.state.currentMonth, "YYYY-MM-DD");
      this.getEventList(date, this.state.studentId, this.state.classId);
    };
    
    window.addEventListener('calendarEventDeleted', this.handleCalendarEventChange);
    window.addEventListener('calendarEventAdded', this.handleCalendarEventChange);
    window.addEventListener('calendarEventUpdated', this.handleCalendarEventChange);
  }

  componentWillUnmount() {
    // Clean up event listeners
    if (this.handleCalendarEventChange) {
      window.removeEventListener('calendarEventDeleted', this.handleCalendarEventChange);
      window.removeEventListener('calendarEventAdded', this.handleCalendarEventChange);
      window.removeEventListener('calendarEventUpdated', this.handleCalendarEventChange);
    }
  }

  fetchSchoolCalenderDocument = (classId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    if (!userDetails.schooleId) return;

    const params = { schooleId: userDetails.schooleId };
    const resolvedClassId = classId || this.state.classId?._id || this.state.classId;
    if (resolvedClassId) {
      params.classId = resolvedClassId;
    }

    CalenderAssignmentService.getCalenderDocument(params)
      .then((res) => {
        const documents = Array.isArray(res)
          ? res.filter((row) => row.schoolCalenderDocument)
          : [];
        this.setState({ schoolCalenderDocuments: documents });
      })
      .catch(() => {
        this.setState({ schoolCalenderDocuments: [] });
      });
  };

  getEventList = (date,studentId,classId) => {
    const colors = ["red", "blue", "green", "orange", "purple", "brown"];
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));

    EventService.calenderassignmentList({ schooleId: userDetails.schooleId, classId:classId?classId:this.state.classId,"studentId":studentId ? studentId :this.state.studentId })
      .then((res) => {
        
        const resulatDetails = (Array.isArray(res) ? res : [])
          .filter((result) => !result.isSchoolCalender)
          .map((result, index) => {
          return {
            ...result,
            eventName: result.eventName ? result.eventName : "",
            date: result.date,
            colorCode: colors[index % colors.length],
          };
        });
        this.setState({
          list: resulatDetails,
          event: { imageURL: [] },
        });
      })
      .catch((err) => {
        this.setState({ error: err.message });
      });
  };

  renderHeader() {
    const dateFormat = "MMMM YYYY";

    return (
      <div className="header row flex-middle calendar-header">
        <div className="col col-start">
          <span className="bg">
            <i
              className="fa fa-arrow-circle-left font-color header-icon"
              onClick={this.prevMonth}
              aria-hidden="true"
            ></i>
          </span>
        </div>
        <div className="col col-center">
          <span className="header-title">{dateFns.format(this.state.currentMonth, dateFormat)}</span>
        </div>
        <div className="col col-end ">
          <span className="bg">
            <i
              className="fa fa-arrow-circle-right font-color header-icon"
              onClick={this.nextMonth}
              aria-hidden="true"
            ></i>
          </span>
        </div>
      </div>
    );
  }

  renderDays() {
    const dateFormat = "ddd";
    const days = [];
    let startDate = dateFns.startOfWeek(this.state.currentMonth, { weekStartsOn: 1 }); // Monday = 1

    for (let i = 0; i < 7; i++) {
      const day = dateFns.addDays(startDate, i);
      const dayName = dateFns.format(day, dateFormat);
      const dayOfWeek = dateFns.getDay(day); // Sunday = 0, Monday = 1, ..., Saturday = 6
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6; // Sunday = 0, Saturday = 6
      
      days.push(
        <div className={`col col-center ${isWeekend ? 'weekend-day' : 'weekday'}`} key={i}>
          {dayName}
        </div>,
      );
    }

    return <div className="days row">{days}</div>;
  }

  findEventByDate = (date) => {
    for (const event of this.state.list) {
      if (event.date === date) {
        return {
          eventName: event.eventName,
          id: event._id,
          imageURL: event.imageURL,
          observation: event.observation,
          iconId: event.iconId,
        };
      }
    }
    return null;
  };

  renderCells() {
    const { currentMonth, selectedDate } = this.state;
    const monthStart = dateFns.startOfMonth(currentMonth);
    const monthEnd = dateFns.endOfMonth(monthStart);
    const startDate = dateFns.startOfWeek(monthStart, { weekStartsOn: 1 }); // Monday = 1
    const endDate = dateFns.endOfWeek(monthEnd, { weekStartsOn: 1 }); // Monday = 1

    const dateFormat = "D";
    const showDateFormate = "YYYY-MM-DD";
    const customer = "MMMM DD YYYY";

    const rows = [];
    let days = [];
    let day = startDate;

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        const datess = dateFns.format(day, showDateFormate);
        const eventDetails = this.findEventByDate(datess);
        const formattedDate = dateFns.format(day, dateFormat);
        const customDateFormat = dateFns.format(day, customer);
        const dayOfWeek = dateFns.getDay(day); // Sunday = 0, Monday = 1, ..., Saturday = 6
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6; // Sunday = 0, Saturday = 6
        const isDisabled = !dateFns.isSameMonth(day, monthStart);
        const isSelected = dateFns.isSameDay(day, selectedDate);
        const isToday = dateFns.isSameDay(day, new Date());
        
        days.push(
          <div
            onClick={() => {
              if (eventDetails?.id) {
                this.handleClick(eventDetails.id, customDateFormat);
              } else {
                this.setState({ userselectedDate: customDateFormat, event: [] });
              }
            }}
            className={`col cell date-cell ${
              isDisabled
                ? "disabled"
                : isSelected
                ? "selected"
                : isWeekend && !isDisabled
                ? "holiday"
                : ""
            }${isToday ? " today" : ""}${eventDetails ? " has-event" : ""}`}
            key={day}
          >
            <span className="number">{formattedDate}</span>

            <div className="scrolling">

              {eventDetails && (
                <>
                  {eventDetails.iconId && eventDetails.iconId.imageUrl ? (
                    <img
                      src={eventDetails.iconId.imageUrl}
                      alt={eventDetails.iconId.iconName || eventDetails.eventName || "Event"}
                      onClick={() => this.handleClick(eventDetails.id, customDateFormat)}
                      className="event-thumb"
                    />
                  ) : eventDetails.imageURL && Array.isArray(eventDetails.imageURL) && eventDetails.imageURL.length > 0 ? (
                    (() => {
                      const firstUrl = eventDetails.imageURL.find(Boolean);
                      const mediaType = getMediaTypeFromUrl(firstUrl);
                      if (mediaType === "video") {
                        return (
                          <Box
                            onClick={() => this.handleClick(eventDetails.id, customDateFormat)}
                            className="event-thumb-video"
                          >
                            <PlayArrowIcon style={{ color: "#fff", fontSize: 32 }} />
                          </Box>
                        );
                      }
                      if (mediaType === "audio") {
                        return (
                          <Box
                            onClick={() => this.handleClick(eventDetails.id, customDateFormat)}
                            className="event-thumb-audio"
                          >
                            <AudiotrackIcon style={{ color: "#1769d6", fontSize: 28 }} />
                          </Box>
                        );
                      }
                      return (
                        <img
                          src={firstUrl}
                          alt={eventDetails.eventName || "Event"}
                          onClick={() => this.handleClick(eventDetails.id, customDateFormat)}
                          className="event-thumb"
                        />
                      );
                    })()
                  ) : (
                    <span style={{ fontWeight: "bold" }}>
                      <EventIcon 
                        onClick={() => this.handleClick(eventDetails.id, customDateFormat)} 
                        className="event-thumb-icon"
                      />
                    </span>
                  )}
                </>
              )}
            </div>
          </div>,
        );
        day = dateFns.addDays(day, 1);
      }

      rows.push(
        <div className="row" key={day}>
          {days}
        </div>,
      );
      days = [];
    }
    return <div className="body">{rows}</div>;
  }

  onDateClick = (day) => {
    this.setState({
      selectedDate: day,
    });
  };

  nextMonth = () => {
    const date = dateFns.format(dateFns.addMonths(this.state.currentMonth, 1), "YYYY-MM-DD");
    this.getEventList(date);
    this.setState({
      currentMonth: dateFns.addMonths(this.state.currentMonth, 1),
    });
  };

  prevMonth = () => {
 
    this.setState({
      currentMonth: dateFns.subMonths(this.state.currentMonth, 1),
    });
  };
   fetchStudentList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    StudentService.findStudentList({ userId: userDetails._id })
      .then((res) => {
        const mappedStudents = res.map((student) => ({
          ...student,
          fullName: `${student.firstName} ${student.lastName}`,
        }));
        this.setState({studentList:mappedStudents});
        if(mappedStudents.length>0){
            // getEventList(mappedStudents[0]._id);
            this.setState({
              studentId:mappedStudents[0]._id,
              classId:mappedStudents[0].classId._id,
            })
            this.fetchSchoolCalenderDocument(mappedStudents[0].classId._id);
            const date = dateFns.format(dateFns.subMonths(this.state.currentMonth, 1), "YYYY-MM-DD");
            this.getEventList(date,mappedStudents[0]._id,mappedStudents[0].classId._id);
        }
        
      })
      .catch((err) => console.error(err));
  };
  handleStudentClick = (studentId,classId) =>{

    this.setState({
      studentId:studentId,
      classId:classId 
    })
console.log(studentId)
const date = dateFns.format(dateFns.subMonths(this.state.currentMonth, 1), "YYYY-MM-DD");

this.getEventList(date,studentId,classId);
    this.fetchSchoolCalenderDocument(classId);
  }

  renderSchoolCalenderCard() {
    const { schoolCalenderDocuments } = this.state;
    if (!schoolCalenderDocuments || schoolCalenderDocuments.length === 0) return null;

    return (
      <div className="school-calender-wrap">
        <div className="school-calender-card">
          <span className="school-calender-deco" aria-hidden="true" />
          <div className="school-calender-card-inner school-calender-card-inner-stack">
            <div className="school-calender-left">
              <div className="school-calender-icon-wrap">
                <CalendarTodayIcon />
              </div>
              <div className="school-calender-meta">
                <span className="school-calender-eyebrow">
                  <DescriptionIcon style={{ fontSize: 14 }} />
                  Official Documents
                </span>
                <h3 className="school-calender-title">School Calendars</h3>
                <p className="school-calender-subtitle">
                  Download the academic calendars shared by your school, including holidays, events, and important dates.
                </p>
              </div>
            </div>
            <div className="school-calender-doc-list">
              {schoolCalenderDocuments.map((doc) => {
                const fileName = getDocumentFileName(doc.schoolCalenderDocument);
                const fileExt = getDocumentExtension(doc.schoolCalenderDocument);
                return (
                  <div className="school-calender-doc-row" key={doc._id}>
                    <div className="school-calender-file">
                      <DescriptionIcon style={{ fontSize: 18, color: "#1769d6", flexShrink: 0 }} />
                      <span className="school-calender-file-name" title={fileName}>
                        {fileName}
                      </span>
                      <span className="school-calender-file-badge">{fileExt}</span>
                    </div>
                    <a
                      className="school-calender-btn school-calender-btn-primary"
                      href={doc.schoolCalenderDocument}
                      download={fileName}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <GetAppIcon style={{ fontSize: 18 }} />
                      Download
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (<div className="calendar-page-wrap">
     <Card sx={{ maxWidth: 345 }}>
                {this.state.studentList.length>1 &&( <Box style={{ margin: 15 }}>
                 <StudentCards studentList={this.state.studentList} onStudentSelect={this.handleStudentClick} />
          
                 </Box>)}
               </Card>
               <br />
      {this.renderSchoolCalenderCard()}
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <div className="calendar">
        

          {this.renderHeader()}
          {this.renderDays()}
          {this.renderCells()}

          {/* Conditionally render the card if there's an event with images */}
        
        </div>
      </Container>
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }} className="calendar-assignments-section">
        <div className="headertitle">
          {this.state.userselectedDate? <h5> {this.state.userselectedDate} Assignment</h5>:''}
           
          </div>
          {this.state.event && this.state.event?.length > 0 && (
  <Grid container spacing={3} sx={{ mt: 2 }}>
    {this.state.event.map((image, index) => (
      <Grid item xs={12} md={6} key={index}>
        <Card className="calendar-assignment-card" sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          {/* Display icon if available */}
          {image.iconId && image.iconId.imageUrl && (
            <Box sx={{ p: 2, textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>
              <img
                src={image.iconId.imageUrl}
                alt={image.iconId.iconName || image.eventName || `Event Icon ${index + 1}`}
                style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px", marginBottom: "8px" }}
              />
              {image.iconId.iconName && (
                <Typography variant="body2" color="text.secondary">
                  Icon: {image.iconId.iconName}
                </Typography>
              )}
            </Box>
          )}
          
          {/* Display all uploaded images below the icon */}
          {image.imageURL && Array.isArray(image.imageURL) && image.imageURL.length > 0 && (
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Uploaded Media
              </Typography>
              <Grid container spacing={2}>
                {image.imageURL.filter(Boolean).map((mediaUrl, imgIndex) => (
                  <Grid item xs={6} sm={4} md={3} key={imgIndex}>
                    {this.renderEventMediaTile(mediaUrl, image.eventName, imgIndex)}
                    <Button
                      size="small"
                      startIcon={<GetAppIcon />}
                      style={{ marginTop: 6, textTransform: "none" }}
                      onClick={() => downloadEventMedia(
                        mediaUrl,
                        image.eventName,
                        getMediaTypeFromUrl(mediaUrl),
                      )}
                    >
                      Download
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          
          <CardContent>
            <Typography variant="h5" gutterBottom>
              {image.eventName}
            </Typography>
            {String(image.observation || '').trim() ? (
              <Box style={{ marginBottom: 12 }}>
                <Typography
                  variant="subtitle2"
                  style={{
                    color: '#9aa6b6',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '0.72rem',
                    letterSpacing: '0.05em',
                    marginBottom: 6,
                  }}
                >
                  Special notes
                </Typography>
                <Typography
                  variant="body1"
                  style={{ color: '#0f2d4d', lineHeight: 1.65, whiteSpace: 'pre-wrap' }}
                >
                  {image.observation}
                </Typography>
              </Box>
            ) : null}
            <Typography variant="body2" color="text.secondary">
              {formatDateDDMMYYYY(image.date)}
            </Typography>
          </CardContent>
          <CardActions sx={{ mt: "auto", justifyContent: "flex-end" }}>
            {image.video && (
              <a href={image.video} target="_blank" rel="noopener noreferrer">
                Watch on YouTube
              </a>
            )}
          </CardActions>
        </Card>
      </Grid>
    ))}
  </Grid>
)}

        </Container>

        <Dialog
          open={this.state.mediaPlayer.open}
          onClose={this.closeMediaPlayer}
          maxWidth="md"
          fullWidth
          PaperProps={{ style: { backgroundColor: "#000", borderRadius: 12 } }}
        >
          <DialogTitle style={{ color: "#fff", backgroundColor: "#0f2d4d" }}>
            {this.state.mediaPlayer.title || "Media"}
            <IconButton
              onClick={this.closeMediaPlayer}
              style={{ position: "absolute", right: 8, top: 8, color: "#fff" }}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ padding: 0, backgroundColor: "#000", textAlign: "center" }}>
            {this.state.mediaPlayer.type === "video" && (
              <video
                key={this.state.mediaPlayer.url}
                src={this.state.mediaPlayer.url}
                controls
                autoPlay
                style={{ width: "100%", maxHeight: "70vh", outline: "none" }}
              />
            )}
            {this.state.mediaPlayer.type === "audio" && (
              <Box p={3}>
                <AudiotrackIcon style={{ color: "#1769d6", fontSize: 48, marginBottom: 16 }} />
                <audio
                  key={this.state.mediaPlayer.url}
                  src={this.state.mediaPlayer.url}
                  controls
                  autoPlay
                  style={{ width: "100%" }}
                />
              </Box>
            )}
            {this.state.mediaPlayer.type === "image" && (
              <img
                src={this.state.mediaPlayer.url}
                alt={this.state.mediaPlayer.title || "Event media"}
                style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
              />
            )}
          </DialogContent>
        </Dialog>
        </div>
    );
  }
}

export default Calendar;
